import { UserRoleType } from "../../../types/admin/User";
import { isType } from "../../enumChecker";

export const canRoleViewProceedingsInProgress = (types: UserRoleType[]) =>
  isUserRoletype(types, "ADMINISTRAATOR", "REGISTRIPIDAJA", "KINNITAJA", "REGISTRI_HALDUR");

export const canRoleViewProceedingMessages = (types: UserRoleType[]) =>
  isUserRoletype(types, "ADMINISTRAATOR", "REGISTRIPIDAJA", "KINNITAJA", "REGISTRI_HALDUR");

export const canRoleViewBalanceMessages = (types: UserRoleType[]) => isUserRoletype(types, "VARAARVESTUS");

export const canRoleViewContractMessages = (types: UserRoleType[]) =>
  isUserRoletype(types, "ADMINISTRAATOR", "REGISTRIPIDAJA", "KINNITAJA", "REGISTRI_HALDUR");

export const canRoleViewRobotMessages = (types: UserRoleType[]) =>
  isUserRoletype(types, "ADMINISTRAATOR", "REGISTRIPIDAJA", "KINNITAJA", "REGISTRI_HALDUR");

export const canRoleViewRealEstateComplexMessages = (types: UserRoleType[]) =>
  isUserRoletype(types, "KVY_HALDUR", "JK_KOORDINAATOR", "JK_KOOSTAJA", "REGISTRI_HALDUR");

const isUserRoletype = (types: UserRoleType[], ...matchTypes: Array<keyof typeof UserRoleType>) => {
  return types.reduce((sum, current) => sum || isType<typeof UserRoleType>(current, ...matchTypes), false);
};
